module.exports = __webpack_public_path__ + "img/delete.6de316e8.svg";